export enum Theme {
  Light = 'light',
  Dark = 'dark',
}

export const THEME_STORAGE_KEY = 'theme-psp';
export const THEMES: Theme[] = Object.values(Theme);
